export default "__VITE_ASSET__69aaf4d2__"